import { useEffect } from 'react'
import { useTheme } from '@/context/ThemeContext'
import Navigation from '@/components/Frontside/Navigation'
import Footer from '@/components/Frontside/Footer'
import { motion } from 'framer-motion'

function AboutPage() {
  const { setTheme } = useTheme()

  useEffect(() => {
    setTheme('light')
  }, [setTheme])

  return (
    <div className="frontside-page bg-background text-foreground">
      <Navigation currentSection="About" searchValue="" onSearchChange={() => {}} />
      <div className="pt-[100px] min-h-screen">
        <section className="px-0 bg-background">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.4 }}
            className="max-w-[1400px] mx-auto px-[5%] min-h-[calc(100vh-100px)] flex items-center"
          >
            <div className="w-full grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12">
              <div>
                <h2 className="text-xl font-semibold mb-6 tracking-tight">Get in Touch</h2>
                <div className="space-y-4">
                  <a
                    href="mailto:mail@christianfiebig.de"
                    className="block text-muted-foreground hover:text-foreground transition-colors"
                  >
                    mail@christianfiebig.de
                  </a>
                  <a
                    href="tel:+46764484847"
                    className="block text-muted-foreground hover:text-foreground transition-colors"
                  >
                    +46 (0) 7644 8484 7
                  </a>
                </div>
              </div>
              <div>
                <h2 className="text-xl font-semibold mb-6 tracking-tight">Social Media</h2>
                <div>
                  <a
                    href="https://www.linkedin.com/in/christianfiebig/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-block"
                  >
                    <img
                      src="https://img.shields.io/badge/LinkedIn-0077B5?style=for-the-badge&logo=linkedin&logoColor=white"
                      alt="LinkedIn"
                      className="h-8 w-auto rounded-full"
                    />
                  </a>
                </div>
              </div>
            </div>
          </motion.div>
        </section>
      </div>
      <Footer />
    </div>
  )
}

export default AboutPage
